"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LD_OVERRIDE_QUERY_FIELD = exports.LD_COOKIE_TLL = exports.LD_OVERRIDE_COOKIE_NAME = exports.LD_USER_COOKIE_NAME = exports.LD_HEADER = exports.setLaunchDarklyData = exports.flagDetailsRoute = exports.transformFlagDetails = exports.fetchFlagDetails = exports.streamCheck = exports.getFlagsFromStream = exports.getFlagsFromLdToken = exports.edgeTokenRoute = exports.spoofLdToken = exports.generateLdToken = exports.getLdToken = exports.setFlagOverrides = exports.assignOverrideFlags = exports.assignFeatureFlags = exports.assignExpFlags = void 0;
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const pattern_library_utils_cookies_1 = require("@saatva-bits/pattern-library.utils.cookies");
const utils_1 = require("../utils");
const LD_HEADER = 'X-LD-CONFIG';
exports.LD_HEADER = LD_HEADER;
const LD_USER_COOKIE_NAME = 'ldu';
exports.LD_USER_COOKIE_NAME = LD_USER_COOKIE_NAME;
const LD_OVERRIDE_COOKIE_NAME = 'ldo';
exports.LD_OVERRIDE_COOKIE_NAME = LD_OVERRIDE_COOKIE_NAME;
const LD_COOKIE_TLL = 1000 * 60 * 60 * 24 * 90;
exports.LD_COOKIE_TLL = LD_COOKIE_TLL;
const LD_OVERRIDE_QUERY_FIELD = 'ldOverrides';
exports.LD_OVERRIDE_QUERY_FIELD = LD_OVERRIDE_QUERY_FIELD;
const LD_QUERY_KEY_VALUE_DELIMETER = '~';
const LD_QUERY_FLAG_DELIMETER = ',';
/**
 * Most recent stream data will be in the x-ld-config header
 * that's set in an Lambda@Edge function in the viewer-request event.
 *
 * To simulate this, use the LD Widget to generate a token
 * and set a custom X-LD-CONFIG header.
*/
const getLdToken = (req) => {
    const ldToken = req.get ? req.get('X-LD-CONFIG') : req.headers['x-ld-config'];
    return ldToken;
};
exports.getLdToken = getLdToken;
const streamCheck = async (ldClient) => {
    const ldReady = ldClient.waitForInitialization();
    const ldTimeout = new Promise((resolve, reject) => {
        setTimeout(() => reject(new Error('Could not connect to LaunchDarkly stream before timeout')), 200);
    });
    return Promise.race([ldReady, ldTimeout]).then((result) => {
        return result;
    }).catch((error) => {
        throw error;
    });
};
exports.streamCheck = streamCheck;
/** Parse or decode LD token (JSON string, JWT, Base64, etc) */
const getFlagsFromLdToken = (ldToken) => {
    const token = JSON.parse(ldToken);
    const { experiments, features } = token;
    return { experiments, features };
};
exports.getFlagsFromLdToken = getFlagsFromLdToken;
/**
 * Fetch all flags directly from LD stream and apply overrides.
*/
const getFlagsFromStream = async (ldClient, req, res) => {
    const ldUserCookie = pattern_library_utils_cookies_1.Cookies.get(LD_USER_COOKIE_NAME, req);
    const uuid = ldUserCookie || req.session.id;
    const user = getUser(uuid);
    /**
   * check all flags (not just client-side designated). That attribute COULD be used
   * for an extra classification
  */
    const allFlags = await ldClient.allFlagsState(user, { clientSideOnly: false });
    /**
    * example output from toJSON() method returned from allFlagsState()
    * (the allValues() method returns just the flag names and values)
    * {
    *  'ENABLE_VR_BANNER_HOME.PD-13886': true,
    *  'EXP.HOMEPAGE_REDESIGN_2.PD-13889': 'v0',
    *  'EXP.MATTRESS_PLP_CONTENT.PD-13963': 'v0',
    *  FT_PLYTIX_STOCK: true,
    *  FT_USER_ACCOUNTS: false,
    *  '$flagsState': {
    *    'ENABLE_VR_BANNER_HOME.PD-13886': { variation: 0, version: 7 },
    *    'EXP.HOMEPAGE_REDESIGN_2.PD-13889': { variation: 0, version: 8 },
    *    'EXP.MATTRESS_PLP_CONTENT.PD-13963': { variation: 0, version: 7 },
    *    FT_PLYTIX_STOCK: { variation: 0, version: 5 },
    *    FT_USER_ACCOUNTS: { variation: 1, version: 22 },
    *    },
    *  '$valid': true
    * }
   */
    const { experiments, features } = parseFlags(allFlags.allValues());
    /* TODO: Should we use something other than a cookie + req.session.id to address users that have cookies turned off? */
    uuid && pattern_library_utils_cookies_1.Cookies.set(LD_USER_COOKIE_NAME, uuid, { req, res, maxAge: LD_COOKIE_TLL }); // 3 months
    return { experiments, features };
};
exports.getFlagsFromStream = getFlagsFromStream;
/* TODO: remove "upToDateFlags" check once the cookies are set
via the Lambda@Edge, as they will always be available. For now
we still want to set the cookies for testing edge caching as
well as possible different patterns for accessing flag values
NOT in the request object
*/
/* retrieve feature and exp cookies */
const assignFeatureFlags = (res, upToDateFlags) => {
    return assignFlags(res, 'featureFlags', upToDateFlags);
};
exports.assignFeatureFlags = assignFeatureFlags;
const assignExpFlags = (res, upToDateFlags) => {
    return assignFlags(res, 'experiments', upToDateFlags);
};
exports.assignExpFlags = assignExpFlags;
const assignOverrideFlags = (res, upToDateFlags) => {
    return assignFlags(res, 'flagOverrides', upToDateFlags);
};
exports.assignOverrideFlags = assignOverrideFlags;
const stripExperimentsForLdToken = (experiments) => {
    return Object.entries(experiments).reduce((flagSet, [key, value]) => {
        const trimmedKey = (0, utils_1.stripExpPrefix)(key);
        return { ...flagSet, [trimmedKey]: value };
    }, {});
};
const stripFeaturesForLdToken = (features, overrides = {}) => {
    return Object.entries(features).reduce((flagSet, [key, value]) => {
        const valueIsTruthy = Boolean(value) && value !== 'v0';
        const keyHasOverride = key in overrides;
        if (valueIsTruthy || keyHasOverride) {
            return { ...flagSet, [key]: value };
        }
        return flagSet;
    }, {});
};
const spoofLdToken = (req, res) => {
    const defaultExperiments = {};
    const defaultFeatures = {};
    const defaultOverrides = setFlagOverrides(req, res, defaultExperiments, defaultFeatures);
    return generateLdToken({ experiments: {}, features: {}, overrides: defaultOverrides });
};
exports.spoofLdToken = spoofLdToken;
/**
 * Generate token from existing experience for local setting of x-ld-config header:
 * Currently surfaced in LD Widget. Must encode token, currently as stringified
 * JSON, could be changed to JWT, Base64, etc
 */
const generateLdToken = ({ experiments = {}, features = {}, overrides = {} }) => {
    /* Strip 'EXP.' prefix from tests, ticket number from features,
  and fitler out features that aren't "truthy" to minimize token */
    const strippedExps = stripExperimentsForLdToken(experiments);
    const strippedFeatures = stripFeaturesForLdToken(features, overrides);
    const token = JSON.stringify({ experiments: strippedExps, features: strippedFeatures, overrides });
    return token;
};
exports.generateLdToken = generateLdToken;
const edgeTokenRoute = (req, res) => {
    const { experiments, featureFlags: features, flagOverrides: overrides } = res.locals;
    const ldToken = generateLdToken({ experiments, features, overrides });
    /* TODO: swap message if we move overrides to edge function */
    const messageWithOverrides = `\n\n\u2605\u2605\u2605\nRemember, if you set the custom header to simulate the edge event, you can still override with the widget.`;
    // const messageWithoutOverrides = `\n\n\u2605\u2605\u2605\nRemember, if you set the custom header to simulate the edge event, you will not be able to override with the widget.`
    res.json({ token: ldToken, message: messageWithOverrides });
};
exports.edgeTokenRoute = edgeTokenRoute;
const setFlagOverrides = (req, res, experiments, features) => {
    const overrides = {};
    /* get existing overrides from override cookie */
    const ldoCookie = pattern_library_utils_cookies_1.Cookies.get(LD_OVERRIDE_COOKIE_NAME, req) || null;
    // no need to encode flags if there are no existing overrides in ldo cookie
    if (ldoCookie) {
        // encode flags to be mapped to encoded overrides in the ldo cookie
        const encodedFlags = (0, utils_1.encodeLdFlags)({ ...experiments, ...features });
        // deconstruct ldo cookie (string) into encoded object
        const encodedOverrides = (0, utils_1.seperateEncodedFlags)(ldoCookie);
        // Build the full flag and variation values from the encoded overrides
        Object.keys(encodedOverrides).forEach((encodedKey) => {
            // if flag matches existing flag key and override variant is different from assigned flag variant
            if (encodedKey in encodedFlags && encodedFlags[encodedKey].encodedVariation !== encodedOverrides[encodedKey]) {
                overrides[encodedFlags[encodedKey].decodedKey] = (0, utils_1.decodeVariant)(encodedOverrides[encodedKey]);
            }
            else {
                overrides[encodedKey] = (0, utils_1.decodeVariant)(encodedOverrides[encodedKey]);
            }
        });
    }
    /* placeholder - get overrides specified in widget */
    /* get overrides specified in query strings */
    const overridesQuery = req.query[LD_OVERRIDE_QUERY_FIELD];
    /* clear all overrides if declared in query param */
    if (overridesQuery === 'clear') {
        pattern_library_utils_cookies_1.Cookies.remove(LD_OVERRIDE_COOKIE_NAME, { req, res });
        return {};
    }
    /* get all query string fields */
    const queryFlags = overridesQuery ? splitQueryFlags(overridesQuery) : [];
    /* convert queryflags to array of key:value flag sets */
    const flagSet = splitQueryFlags(LD_QUERY_FLAG_DELIMETER).concat(queryFlags);
    // Set override flags from query string
    flagSet.length > 0 && flagSet.forEach((flagSet) => {
        // check if provided query field matches any experiment or feature flags
        const [flagKey, value] = flagSet.split(LD_QUERY_KEY_VALUE_DELIMETER);
        /* assume if a key isn't in the exp or features list, that it is a feature flag
    that is "off" and filtered out of the set to minimize tokensize (stripFeaturesForLdToken) */
        let assignedFlagValue = false;
        if (flagKey in experiments) {
            assignedFlagValue = experiments[flagKey];
        }
        else if (flagKey in features) {
            assignedFlagValue = features[flagKey];
        }
        const flagOverrideValue = (0, utils_1.decodeVariant)(value);
        // check that the override isn't identical to the value already assigned
        if (assignedFlagValue !== flagOverrideValue) {
            overrides[flagKey] = flagOverrideValue;
        }
        else {
            // override matches assigned variant, remove any persisting override from request
            delete overrides[flagKey];
        }
    });
    if (Object.keys(overrides).length !== 0) {
        const encodedCookie = (0, utils_1.encodeLdCookieValue)(overrides);
        pattern_library_utils_cookies_1.Cookies.set(LD_OVERRIDE_COOKIE_NAME, encodedCookie, { req, res, maxAge: LD_COOKIE_TLL }); // 3 months
    }
    return overrides;
};
exports.setFlagOverrides = setFlagOverrides;
const splitQueryFlags = (query, delimeter = LD_QUERY_FLAG_DELIMETER) => query.split(delimeter).filter(flag => flag);
const assignFlags = (res, localVarName, upToDateFlags) => {
    res.locals[localVarName] = upToDateFlags || {};
};
const getUser = (uuid) => {
    return {
        key: uuid,
        anonymous: false
    };
};
const parseFlags = (flags) => {
    return Object.keys(flags).reduce((values, flagKey) => {
        let { experiments, features } = values;
        if (flagKey.startsWith('EXP.')) {
            experiments = {
                ...experiments,
                [flagKey]: flags[flagKey]
            };
        }
        else {
            features = {
                ...features,
                [flagKey]: flags[flagKey]
            };
        }
        return {
            experiments,
            features
        };
    }, { features: {}, experiments: {} });
};
// Latest API version is 20240415 uses paginated requests. The maximum limit for the `list feature flags` request is 100. By default it is 20.
const fetchFlagDetails = async (ldKey, isProd = true, ldUrl = 'https://app.launchdarkly.com/api/v2/flags/default?limit=100&offset=0') => {
    const ldEnv = isProd ? 'production' : 'test';
    const ldUrlWithEnv = `${ldUrl}&filter=filterEnv:${ldEnv}`; // The environment field is only returned if the request is filtered by the environment in the 20240415 api version.
    try {
        const flagDetailsResponse = await fetch(ldUrlWithEnv, {
            headers: {
                'LD-API-Version': 20240415,
                Authorization: ldKey
            }
        });
        return flagDetailsResponse.json();
    }
    catch (error) {
        console.log(`[service.launchDarkly.getFlags]: Error getting flags`);
        throw new Error(error.message);
    }
};
exports.fetchFlagDetails = fetchFlagDetails;
const transformFlagDetails = (flagDetails, featureFlags, experiments, overrides, isProd = true) => {
    const ldEnv = isProd ? 'production' : 'test';
    const flagData = flagDetails.items.map((flag) => {
        const { key: originalKey, name, kind, tags, creationDate, description, environments, variations } = flag;
        const key = (0, utils_1.stripExpPrefix)(originalKey);
        const envData = environments[ldEnv];
        const splits = Object.values(envData._summary.variations).map(variation => variation.rollout / 1000).filter(Boolean);
        const valueOptions = variations.map(variation => variation.value);
        /* Assumes launch darkly will always provide the default "off" value in this way */
        const defaultOffValueIndex = Object.entries(environments[ldEnv]._summary.variations).find((entity) => entity[1].isOff)[0];
        const defaultOffValue = valueOptions[defaultOffValueIndex];
        /* Set the initial value, before overrides are applied, to persist users' original variation */
        const initialValue = experiments[key] || featureFlags[key] || defaultOffValue;
        let currentValue = null;
        if (overrides[key] !== undefined) {
            currentValue = overrides[key];
        }
        else if (experiments[key] !== undefined) {
            currentValue = experiments[key];
        }
        else if (featureFlags[key] !== undefined) {
            currentValue = featureFlags[key];
        }
        const isFeatureFlag = !(key in experiments); // we are trimming the official list of features if they're "false" so not all feature keys are in the res.local.featureFlags object
        const isExperiment = key in experiments;
        const isOverridden = key in overrides;
        const { ticket } = (0, utils_1.parseLdFlagKey)(key);
        const jiraUrl = ticket ? `https://saatva.atlassian.net/browse/${ticket}` : null;
        const launchDarklyUrl = `https://app.launchdarkly.com/default/${ldEnv}/features/${key}/targeting`;
        return {
            flagKey: key,
            isOn: envData.on,
            name,
            kind,
            tags,
            defaultOffValue,
            description,
            creationDate,
            valueOptions,
            splits,
            currentValue,
            initialValue,
            isFeatureFlag,
            isExperiment,
            isOverridden,
            jiraUrl,
            launchDarklyUrl,
            jiraTicket: ticket
        };
    });
    return flagData;
};
exports.transformFlagDetails = transformFlagDetails;
const flagDetailsRoute = async (req, res, ldKey, isProd) => {
    const flagDetails = await fetchFlagDetails(ldKey, isProd);
    const featureFlags = res.locals.featureFlags || {};
    const experiments = res.locals.experiments || {};
    const overrides = res.locals.flagOverrides || {};
    const transformedFlagDetails = transformFlagDetails(flagDetails, featureFlags, experiments, overrides, isProd);
    return res.json(transformedFlagDetails);
};
exports.flagDetailsRoute = flagDetailsRoute;
const setLaunchDarklyData = async (req, res) => {
    var _a, _b;
    let ldToken = getLdToken(req);
    /* If token dosen't exist, generate it for consistent evaluation
      with the edge function that should create it As this should only
      happen locally, we can default ldToken with only override values
      (defaults can be set with LAUNCH_DARKLY_DEFAULT_FLAG_QUERY env var) */
    if (!ldToken) {
        ldToken = spoofLdToken(req, res);
    }
    /* use ldToken (set in ViewerRequest event in Lambda@Edge or spoofed for local development from stream */
    /* NOTE: ld user and override cookies are set and referenced in edge as well */
    const { experiments, features } = getFlagsFromLdToken(ldToken);
    /* TODO: swap message in /edge-token route if we move overrides to edge function */
    const overrides = setFlagOverrides(req, res, experiments, features);
    const userAgent = req.get ? req.get('User-Agent') : req.headers['user-agent'];
    /* Make feature and experiment flags available to application */
    /* When we move the cookie setting the Edge, we'll always have the cookie in the request object. */
    assignFeatureFlags(res, features);
    assignExpFlags(res, experiments);
    assignOverrideFlags(res, overrides);
    /* Determine LD Widget View */
    res.locals.displayLDWidget = ((_a = req.query) === null || _a === void 0 ? void 0 : _a.ldtest) === 'true';
    res.locals.displaySiteConfig = ((_b = req.query) === null || _b === void 0 ? void 0 : _b.ldtest) === 'config';
};
exports.setLaunchDarklyData = setLaunchDarklyData;
//# sourceMappingURL=middleware.js.map